// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  AddClientClientsPostData,
  AddClientClientsPostResponse,
  BuildSlicesIntradayAlgoBuildSlicesPostData,
  BuildSlicesIntradayAlgoBuildSlicesPostResponse,
  CancelInnovaAlgoTradesByPtuIntradayAlgoInnovaAlgoTradesByPtuDeleteData,
  CancelInnovaAlgoTradesByPtuIntradayAlgoInnovaAlgoTradesByPtuDeleteResponse,
  CheckSignalsAlgoIntradayAlgoSignalsAlgoCheckPostData,
  CheckSignalsAlgoIntradayAlgoSignalsAlgoCheckPostResponse,
  CreateSuperuserSuperusersPostData,
  CreateSuperuserSuperusersPostResponse,
  CreateUploadFilePriceUpdateUploadfilePostData,
  CreateUploadFilePriceUpdateUploadfilePostResponse,
  CreateUserUsersPostData,
  CreateUserUsersPostResponse,
  DeactivateSuperuserSuperusersUserIdDeleteData,
  DeactivateSuperuserSuperusersUserIdDeleteResponse,
  DeleteAllInnovaAlgoTradesIntradayAlgoInnovaAlgoTradesDeleteResponse,
  DeleteEtpaOrdersAutoTraderDeleteEtpaOrdersDeleteData,
  DeleteEtpaOrdersAutoTraderDeleteEtpaOrdersDeleteResponse,
  DeleteOrdersAutoTraderDeleteOrdersDeleteData,
  DeleteOrdersAutoTraderDeleteOrdersDeleteResponse,
  DeleteUserUsersUserIdDeleteData,
  DeleteUserUsersUserIdDeleteResponse,
  GetClientsByUserIdUsersUserIdClientsGetData,
  GetClientsByUserIdUsersUserIdClientsGetResponse,
  GetEtpaOrdersAutoTraderEtpaOrdersGetResponse,
  GetOrdersSu2mAutoTraderDbOrdersGetResponse,
  GetPriceUpdateDataByDatePriceUpdateGetData,
  GetPriceUpdateDataByDatePriceUpdateGetResponse,
  GetRunsIntradayAlgoRunsGetData,
  GetRunsIntradayAlgoRunsGetResponse,
  GetSignalsIntradayAlgoSignalsGetData,
  GetSignalsIntradayAlgoSignalsGetResponse,
  GetSlicesIntradayAlgoSlicesGetData,
  GetSlicesIntradayAlgoSlicesGetResponse,
  GetTradingLimitsIntradayAlgoTradingLimitsGetData,
  GetTradingLimitsIntradayAlgoTradingLimitsGetResponse,
  GetTransformadPriceUpdateEmailDataPriceUpdateTransformedPriceUpdateEmailDataGetData,
  GetTransformadPriceUpdateEmailDataPriceUpdateTransformedPriceUpdateEmailDataGetResponse,
  GetWorkerStatusAutoTraderWorkerStatusGetResponse,
  GetWorkerStatusIntradayAlgoWorkerStatusGetResponse,
  OverrideTradingLimitsIntradayAlgoTradingLimitsPutData,
  OverrideTradingLimitsIntradayAlgoTradingLimitsPutResponse,
  PauseWorkerAutoTraderWorkerPausePostResponse,
  PauseWorkerIntradayAlgoWorkerPausePostResponse,
  ReadClientClientsClientIdGetData,
  ReadClientClientsClientIdGetResponse,
  ReadClientsClientsGetData,
  ReadClientsClientsGetResponse,
  ReadClientsFromOfficeDbClientsOfficeGetResponse,
  ReadSparkspreadPricesSparkspreadGetResponse,
  ReadSuperuserByIdSuperusersUserIdGetData,
  ReadSuperuserByIdSuperusersUserIdGetResponse,
  ReadSuperusersSuperusersGetData,
  ReadSuperusersSuperusersGetResponse,
  ReadUserByIdUsersUserIdGetData,
  ReadUserByIdUsersUserIdGetResponse,
  ReadUserClientLinksWithPermissionsUserClientLinksGetResponse,
  ReadUsersUsersGetData,
  ReadUsersUsersGetResponse,
  RepostAllOrdersAutoTraderRepostAllOrdersPostData,
  RepostAllOrdersAutoTraderRepostAllOrdersPostResponse,
  ResendInviteUsersUserIdResendInvitePostData,
  ResendInviteUsersUserIdResendInvitePostResponse,
  ResetPriceUpdateSentStatusPriceUpdateResetSentStatusPostData,
  ResetPriceUpdateSentStatusPriceUpdateResetSentStatusPostResponse,
  ResumeWorkerAutoTraderWorkerResumePostResponse,
  ResumeWorkerIntradayAlgoWorkerResumePostResponse,
  SendPriceUpdateEmailsPriceUpdateSendEmailPostData,
  SendPriceUpdateEmailsPriceUpdateSendEmailPostResponse,
  SyncClientsClientsSyncPostResponse,
  UnlinkUserFromClientUserClientLinksUserIdClientIdDeleteData,
  UnlinkUserFromClientUserClientLinksUserIdClientIdDeleteResponse,
  UpdateClientClientsClientIdPutData,
  UpdateClientClientsClientIdPutResponse,
  UpdateSignalsAlgoIntradayAlgoSignalsAlgoPatchData,
  UpdateSignalsAlgoIntradayAlgoSignalsAlgoPatchResponse,
  UpdateSuperuserSuperusersUserIdPatchData,
  UpdateSuperuserSuperusersUserIdPatchResponse,
  UpdateUserClientLinkUserClientLinksUserIdClientIdPatchData,
  UpdateUserClientLinkUserClientLinksUserIdClientIdPatchResponse,
  UpdateUserUsersUserIdPatchData,
  UpdateUserUsersUserIdPatchResponse,
  ValidateContractNamesPriceUpdateValidateContractNamesGetResponse,
} from "./types.gen";

/**
 * Read Users
 * Retrieve users.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @returns UsersWithClientLinks Successful Response
 * @throws ApiError
 */
export const readUsersUsersGet = (data: ReadUsersUsersGetData = {}): CancelablePromise<ReadUsersUsersGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/users/",
    query: {
      skip: data.skip,
      limit: data.limit,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Create User
 * Create new user.
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.welcomeEmailLanguage
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const createUserUsersPost = (data: CreateUserUsersPostData): CancelablePromise<CreateUserUsersPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/users/",
    query: {
      welcome_email_language: data.welcomeEmailLanguage,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read User By Id
 * Get a specific user by id. Superusers are managed via /superusers.
 * @param data The data for the request.
 * @param data.userId
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const readUserByIdUsersUserIdGet = (
  data: ReadUserByIdUsersUserIdGetData,
): CancelablePromise<ReadUserByIdUsersUserIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/users/{user_id}",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update User
 * Update a user.
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const updateUserUsersUserIdPatch = (
  data: UpdateUserUsersUserIdPatchData,
): CancelablePromise<UpdateUserUsersUserIdPatchResponse> => {
  return __request(OpenAPI, {
    method: "PATCH",
    url: "/users/{user_id}",
    path: {
      user_id: data.userId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Delete User
 * Delete a user. Superusers are managed via /superusers.
 * @param data The data for the request.
 * @param data.userId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const deleteUserUsersUserIdDelete = (
  data: DeleteUserUsersUserIdDeleteData,
): CancelablePromise<DeleteUserUsersUserIdDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/users/{user_id}",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Clients By User Id
 * @param data The data for the request.
 * @param data.userId
 * @returns ClientsPublic Successful Response
 * @throws ApiError
 */
export const getClientsByUserIdUsersUserIdClientsGet = (
  data: GetClientsByUserIdUsersUserIdClientsGetData,
): CancelablePromise<GetClientsByUserIdUsersUserIdClientsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/users/{user_id}/clients",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Resend Invite
 * @param data The data for the request.
 * @param data.userId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const resendInviteUsersUserIdResendInvitePost = (
  data: ResendInviteUsersUserIdResendInvitePostData,
): CancelablePromise<ResendInviteUsersUserIdResendInvitePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/users/{user_id}/resend-invite",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Superusers
 * Retrieve superusers.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @returns UsersWithClientLinks Successful Response
 * @throws ApiError
 */
export const readSuperusersSuperusersGet = (
  data: ReadSuperusersSuperusersGetData = {},
): CancelablePromise<ReadSuperusersSuperusersGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/superusers/",
    query: {
      skip: data.skip,
      limit: data.limit,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Create Superuser
 * Create a new superuser. The client link is forced to the admin client and
 * price-update preference fields are always cleared.
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.welcomeEmailLanguage
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const createSuperuserSuperusersPost = (
  data: CreateSuperuserSuperusersPostData,
): CancelablePromise<CreateSuperuserSuperusersPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/superusers/",
    query: {
      welcome_email_language: data.welcomeEmailLanguage,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Superuser By Id
 * Get a specific superuser by id.
 * @param data The data for the request.
 * @param data.userId
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const readSuperuserByIdSuperusersUserIdGet = (
  data: ReadSuperuserByIdSuperusersUserIdGetData,
): CancelablePromise<ReadSuperuserByIdSuperusersUserIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/superusers/{user_id}",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update Superuser
 * Update a superuser.
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const updateSuperuserSuperusersUserIdPatch = (
  data: UpdateSuperuserSuperusersUserIdPatchData,
): CancelablePromise<UpdateSuperuserSuperusersUserIdPatchResponse> => {
  return __request(OpenAPI, {
    method: "PATCH",
    url: "/superusers/{user_id}",
    path: {
      user_id: data.userId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Deactivate Superuser
 * Deactivate a superuser (soft delete: sets is_active to false).
 * @param data The data for the request.
 * @param data.userId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const deactivateSuperuserSuperusersUserIdDelete = (
  data: DeactivateSuperuserSuperusersUserIdDeleteData,
): CancelablePromise<DeactivateSuperuserSuperusersUserIdDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/superusers/{user_id}",
    path: {
      user_id: data.userId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Clients From Office Db
 * @returns Clients Successful Response
 * @throws ApiError
 */
export const readClientsFromOfficeDbClientsOfficeGet =
  (): CancelablePromise<ReadClientsFromOfficeDbClientsOfficeGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/clients/office",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Sync Clients
 * @returns SyncClientsResponse Successful Response
 * @throws ApiError
 */
export const syncClientsClientsSyncPost = (): CancelablePromise<SyncClientsClientsSyncPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/clients/sync",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Clients
 * Retrieve clients with users.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @returns ClientsWithUsers Successful Response
 * @throws ApiError
 */
export const readClientsClientsGet = (
  data: ReadClientsClientsGetData = {},
): CancelablePromise<ReadClientsClientsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/clients/",
    query: {
      skip: data.skip,
      limit: data.limit,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Add Client
 * Create new client.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientPublic Successful Response
 * @throws ApiError
 */
export const addClientClientsPost = (
  data: AddClientClientsPostData,
): CancelablePromise<AddClientClientsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/clients/",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read Client
 * @param data The data for the request.
 * @param data.clientId
 * @returns ClientPublic Successful Response
 * @throws ApiError
 */
export const readClientClientsClientIdGet = (
  data: ReadClientClientsClientIdGetData,
): CancelablePromise<ReadClientClientsClientIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/clients/{client_id}",
    path: {
      client_id: data.clientId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update Client
 * Update client.
 * @param data The data for the request.
 * @param data.clientId
 * @param data.requestBody
 * @returns ClientPublic Successful Response
 * @throws ApiError
 */
export const updateClientClientsClientIdPut = (
  data: UpdateClientClientsClientIdPutData,
): CancelablePromise<UpdateClientClientsClientIdPutResponse> => {
  return __request(OpenAPI, {
    method: "PUT",
    url: "/clients/{client_id}",
    path: {
      client_id: data.clientId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Read User Client Links With Permissions
 * Retrieve all users with their associated clients and permissions.
 * @returns UsersClientsPermissions Successful Response
 * @throws ApiError
 */
export const readUserClientLinksWithPermissionsUserClientLinksGet =
  (): CancelablePromise<ReadUserClientLinksWithPermissionsUserClientLinksGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/user-client-links/",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Update User Client Link
 * @param data The data for the request.
 * @param data.userId
 * @param data.clientId
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const updateUserClientLinkUserClientLinksUserIdClientIdPatch = (
  data: UpdateUserClientLinkUserClientLinksUserIdClientIdPatchData,
): CancelablePromise<UpdateUserClientLinkUserClientLinksUserIdClientIdPatchResponse> => {
  return __request(OpenAPI, {
    method: "PATCH",
    url: "/user-client-links/{user_id}/{client_id}",
    path: {
      user_id: data.userId,
      client_id: data.clientId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Unlink User From Client
 * @param data The data for the request.
 * @param data.userId
 * @param data.clientId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const unlinkUserFromClientUserClientLinksUserIdClientIdDelete = (
  data: UnlinkUserFromClientUserClientLinksUserIdClientIdDeleteData,
): CancelablePromise<UnlinkUserFromClientUserClientLinksUserIdClientIdDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/user-client-links/{user_id}/{client_id}",
    path: {
      user_id: data.userId,
      client_id: data.clientId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Price Update Data By Date
 * @param data The data for the request.
 * @param data.date
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getPriceUpdateDataByDatePriceUpdateGet = (
  data: GetPriceUpdateDataByDatePriceUpdateGetData = {},
): CancelablePromise<GetPriceUpdateDataByDatePriceUpdateGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/price-update/",
    query: {
      date: data.date,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Transformad Price Update Email Data
 * @param data The data for the request.
 * @param data.date
 * @returns TransformPriceUpdateEmailDataResponse Successful Response
 * @throws ApiError
 */
export const getTransformadPriceUpdateEmailDataPriceUpdateTransformedPriceUpdateEmailDataGet = (
  data: GetTransformadPriceUpdateEmailDataPriceUpdateTransformedPriceUpdateEmailDataGetData = {},
): CancelablePromise<GetTransformadPriceUpdateEmailDataPriceUpdateTransformedPriceUpdateEmailDataGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/price-update/transformed-price-update-email-data",
    query: {
      date: data.date,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Validate Contract Names
 * @returns ContractNameValidationResult Successful Response
 * @throws ApiError
 */
export const validateContractNamesPriceUpdateValidateContractNamesGet =
  (): CancelablePromise<ValidateContractNamesPriceUpdateValidateContractNamesGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/price-update/validate-contract-names",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Create Upload File
 * @param data The data for the request.
 * @param data.formData
 * @param data.enableContractValidation
 * @returns EstimatedPriceUpdateRecord Successful Response
 * @throws ApiError
 */
export const createUploadFilePriceUpdateUploadfilePost = (
  data: CreateUploadFilePriceUpdateUploadfilePostData,
): CancelablePromise<CreateUploadFilePriceUpdateUploadfilePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/price-update/uploadfile/",
    query: {
      enable_contract_validation: data.enableContractValidation,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Send Price Update Emails
 * @param data The data for the request.
 * @param data.message
 * @returns Message Successful Response
 * @throws ApiError
 */
export const sendPriceUpdateEmailsPriceUpdateSendEmailPost = (
  data: SendPriceUpdateEmailsPriceUpdateSendEmailPostData = {},
): CancelablePromise<SendPriceUpdateEmailsPriceUpdateSendEmailPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/price-update/send_email",
    query: {
      message: data.message,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Reset Price Update Sent Status
 * @param data The data for the request.
 * @param data.date
 * @returns Message Successful Response
 * @throws ApiError
 */
export const resetPriceUpdateSentStatusPriceUpdateResetSentStatusPost = (
  data: ResetPriceUpdateSentStatusPriceUpdateResetSentStatusPostData = {},
): CancelablePromise<ResetPriceUpdateSentStatusPriceUpdateResetSentStatusPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/price-update/reset-sent-status",
    query: {
      date: data.date,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Orders Su2M
 * @returns OrdersSu2mResponseModel Successful Response
 * @throws ApiError
 */
export const getOrdersSu2mAutoTraderDbOrdersGet = (): CancelablePromise<GetOrdersSu2mAutoTraderDbOrdersGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/auto-trader/db-orders",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Etpa Orders
 * @returns EtpaOrderResponseModel Successful Response
 * @throws ApiError
 */
export const getEtpaOrdersAutoTraderEtpaOrdersGet =
  (): CancelablePromise<GetEtpaOrdersAutoTraderEtpaOrdersGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/auto-trader/etpa-orders",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Pause Worker
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const pauseWorkerAutoTraderWorkerPausePost =
  (): CancelablePromise<PauseWorkerAutoTraderWorkerPausePostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/auto-trader/worker/pause",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Resume Worker
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const resumeWorkerAutoTraderWorkerResumePost =
  (): CancelablePromise<ResumeWorkerAutoTraderWorkerResumePostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/auto-trader/worker/resume",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Get Worker Status
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const getWorkerStatusAutoTraderWorkerStatusGet =
  (): CancelablePromise<GetWorkerStatusAutoTraderWorkerStatusGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/auto-trader/worker/status",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Delete Orders
 * Set deleted status in the database and cancel orders from ETPA
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const deleteOrdersAutoTraderDeleteOrdersDelete = (
  data: DeleteOrdersAutoTraderDeleteOrdersDeleteData,
): CancelablePromise<DeleteOrdersAutoTraderDeleteOrdersDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/auto-trader/delete-orders",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Delete Etpa Orders
 * Cancel orders from ETPA
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteEtpaOrdersResponse Successful Response
 * @throws ApiError
 */
export const deleteEtpaOrdersAutoTraderDeleteEtpaOrdersDelete = (
  data: DeleteEtpaOrdersAutoTraderDeleteEtpaOrdersDeleteData,
): CancelablePromise<DeleteEtpaOrdersAutoTraderDeleteEtpaOrdersDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/auto-trader/delete-etpa-orders",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Repost All Orders
 * Repost all open orders to ETPA
 * @param data The data for the request.
 * @param data.skipOpenOrdersCheck
 * @returns EtpaRepostAllOpenOrdersResponse Successful Response
 * @throws ApiError
 */
export const repostAllOrdersAutoTraderRepostAllOrdersPost = (
  data: RepostAllOrdersAutoTraderRepostAllOrdersPostData = {},
): CancelablePromise<RepostAllOrdersAutoTraderRepostAllOrdersPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/auto-trader/repost-all-orders",
    query: {
      skip_open_orders_check: data.skipOpenOrdersCheck,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Runs
 * @param data The data for the request.
 * @param data.deliveryDate
 * @param data.offset
 * @param data.limit
 * @returns RunsResponseModel Successful Response
 * @throws ApiError
 */
export const getRunsIntradayAlgoRunsGet = (
  data: GetRunsIntradayAlgoRunsGetData = {},
): CancelablePromise<GetRunsIntradayAlgoRunsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/intraday-algo/runs",
    query: {
      delivery_date: data.deliveryDate,
      offset: data.offset,
      limit: data.limit,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Signals
 * @param data The data for the request.
 * @param data.lastUpdate
 * @param data.intradayCode
 * @returns SignalsResponseModel Successful Response
 * @throws ApiError
 */
export const getSignalsIntradayAlgoSignalsGet = (
  data: GetSignalsIntradayAlgoSignalsGetData,
): CancelablePromise<GetSignalsIntradayAlgoSignalsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/intraday-algo/signals",
    query: {
      last_update: data.lastUpdate,
      intraday_code: data.intradayCode,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update Signals Algo
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateAlgoResponse Successful Response
 * @throws ApiError
 */
export const updateSignalsAlgoIntradayAlgoSignalsAlgoPatch = (
  data: UpdateSignalsAlgoIntradayAlgoSignalsAlgoPatchData,
): CancelablePromise<UpdateSignalsAlgoIntradayAlgoSignalsAlgoPatchResponse> => {
  return __request(OpenAPI, {
    method: "PATCH",
    url: "/intraday-algo/signals/algo",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Check Signals Algo
 * Dry run of enabling these signals (Algo=1): the trading limit checks
 * PATCH /signals/algo would run, without changing anything.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TradingLimitCheck Successful Response
 * @throws ApiError
 */
export const checkSignalsAlgoIntradayAlgoSignalsAlgoCheckPost = (
  data: CheckSignalsAlgoIntradayAlgoSignalsAlgoCheckPostData,
): CancelablePromise<CheckSignalsAlgoIntradayAlgoSignalsAlgoCheckPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/intraday-algo/signals/algo/check",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Trading Limits
 * @param data The data for the request.
 * @param data.deliveryDate
 * @returns TradingLimitsResponse Successful Response
 * @throws ApiError
 */
export const getTradingLimitsIntradayAlgoTradingLimitsGet = (
  data: GetTradingLimitsIntradayAlgoTradingLimitsGetData,
): CancelablePromise<GetTradingLimitsIntradayAlgoTradingLimitsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/intraday-algo/trading-limits",
    query: {
      delivery_date: data.deliveryDate,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Override Trading Limits
 * Override every limit for one delivery date. The latest override wins;
 * the client's defaults change by migration only.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TradingLimitsResponse Successful Response
 * @throws ApiError
 */
export const overrideTradingLimitsIntradayAlgoTradingLimitsPut = (
  data: OverrideTradingLimitsIntradayAlgoTradingLimitsPutData,
): CancelablePromise<OverrideTradingLimitsIntradayAlgoTradingLimitsPutResponse> => {
  return __request(OpenAPI, {
    method: "PUT",
    url: "/intraday-algo/trading-limits",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Slices
 * Fetch slices, optionally filtered by contract and/or status.
 * @param data The data for the request.
 * @param data.deliveryDate
 * @param data.start
 * @param data.end
 * @param data.intradayCode
 * @param data.status
 * @returns SlicesResponseModel Successful Response
 * @throws ApiError
 */
export const getSlicesIntradayAlgoSlicesGet = (
  data: GetSlicesIntradayAlgoSlicesGetData,
): CancelablePromise<GetSlicesIntradayAlgoSlicesGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/intraday-algo/slices",
    query: {
      delivery_date: data.deliveryDate,
      start: data.start,
      end: data.end,
      intraday_code: data.intradayCode,
      status: data.status,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Build Slices
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BuildSlicesResponse Successful Response
 * @throws ApiError
 */
export const buildSlicesIntradayAlgoBuildSlicesPost = (
  data: BuildSlicesIntradayAlgoBuildSlicesPostData,
): CancelablePromise<BuildSlicesIntradayAlgoBuildSlicesPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/intraday-algo/build-slices",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Delete All Innova Algo Trades
 * Cancel all pending/active innova algo trades for today and future delivery dates.
 *
 * Requires the worker to be paused. Cancels ETPA orders for trades that have
 * an active order on ETPA, then marks all non-terminal trades as CANCELLED.
 * Resets all Algo=2 signals with DeliveryDate >= today back to Algo=0.
 *
 * Also queries ETPA for any remaining orders with the Innova intradayCode
 * and cancels them too. Orders found on ETPA but not in our DB are logged
 * as warnings. DB trades matching a cancelled order ID are marked CANCELLED.
 * @returns DeleteAllInnovaAlgoTradesResponse Successful Response
 * @throws ApiError
 */
export const deleteAllInnovaAlgoTradesIntradayAlgoInnovaAlgoTradesDelete =
  (): CancelablePromise<DeleteAllInnovaAlgoTradesIntradayAlgoInnovaAlgoTradesDeleteResponse> => {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/intraday-algo/innova-algo-trades",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Cancel Innova Algo Trades By Ptu
 * Cancel all pending/active innova algo trades for a single PTU.
 *
 * Requires the worker to be paused. Scoped to `delivery_date + start + end`
 * and Innova's fixed intraday code. Cancels ETPA orders for affected trades,
 * marks them CANCELLED, and resets Algo=2 signals for the same PTU to
 * Algo=0 so the user can re-enable them via Algo=1 + rebuild.
 *
 * Defensive orphan cancel by intradayCode is intentionally out of scope for
 * this endpoint â€” use Delete All for that.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CancelPtuOrdersResponse Successful Response
 * @throws ApiError
 */
export const cancelInnovaAlgoTradesByPtuIntradayAlgoInnovaAlgoTradesByPtuDelete = (
  data: CancelInnovaAlgoTradesByPtuIntradayAlgoInnovaAlgoTradesByPtuDeleteData,
): CancelablePromise<CancelInnovaAlgoTradesByPtuIntradayAlgoInnovaAlgoTradesByPtuDeleteResponse> => {
  return __request(OpenAPI, {
    method: "DELETE",
    url: "/intraday-algo/innova-algo-trades/by-ptu",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Pause Worker
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const pauseWorkerIntradayAlgoWorkerPausePost =
  (): CancelablePromise<PauseWorkerIntradayAlgoWorkerPausePostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/intraday-algo/worker/pause",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Resume Worker
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const resumeWorkerIntradayAlgoWorkerResumePost =
  (): CancelablePromise<ResumeWorkerIntradayAlgoWorkerResumePostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/intraday-algo/worker/resume",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Get Worker Status
 * @returns WorkerStateResponse Successful Response
 * @throws ApiError
 */
export const getWorkerStatusIntradayAlgoWorkerStatusGet =
  (): CancelablePromise<GetWorkerStatusIntradayAlgoWorkerStatusGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/intraday-algo/worker/status",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Read Sparkspread Prices
 * @returns ListOfPriceItems Successful Response
 * @throws ApiError
 */
export const readSparkspreadPricesSparkspreadGet =
  (): CancelablePromise<ReadSparkspreadPricesSparkspreadGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/sparkspread/",
      errors: {
        422: "Validation Error",
      },
    });
  };
